<template lang="html">
  <div class="container">
    “专题”开发中
  </div>
</template>

<script>

  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
      };
    },
    computed: {
    },
    methods: {
    },
    mounted () {
    },
    destroyed () {
    }
  }
</script>

<style lang="css" scoped>
  
</style>
